import axios from 'axios';
import Vue from 'vue';

const AxiosPlugin = {};
AxiosPlugin.install = function (Vue) {
    Vue.prototype.$axios = axios;
};

Vue.use(AxiosPlugin);